var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "nav-switcher" },
    [
      _c(
        "b-navbar-nav",
        { staticClass: "ml-auto" },
        [
          _c(
            "b-nav-item-dropdown",
            [
              _c("template", { slot: "button-content" }, [
                _c("img", {
                  staticClass: "country-icon as-toggle",
                  attrs: { src: _vm.icons[_vm.currentLocale] },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { on: { click: _vm.localeChange } },
                _vm._l(_vm.locales, function (locale) {
                  return _c(
                    "router-link",
                    {
                      key: locale.code,
                      staticClass: "dropdown-item",
                      attrs: { to: `/${locale.code}/` + _vm.currentSubRoute },
                    },
                    [
                      _c("img", {
                        staticClass: "country-icon",
                        attrs: { src: _vm.icons[locale.code] },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "locale-name" }, [
                        _vm._v(_vm._s(locale.name)),
                      ]),
                    ]
                  )
                }),
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }